import { client } from './api-client';

/**
 * Eye tests enabled for the practice running the appointment, as
 * { [categoryId]: { title, key, thumbnail_url, tests: [...] } }.
 *
 * Read from api/appointments/<id>/tests/ so the picker lists the appointment's practice tests whichever account
 * opened the session. Falls back to the viewer's own company (api/companies/current/) when there is no appointment
 * yet or the API predates that endpoint.
 */
export const fetchPracticeTests = async (appointmentId) => {
  if (appointmentId) {
    try {
      const data = await client(`api/appointments/${appointmentId}/tests/`);
      if (data?.enabled_categorised_tests) return data.enabled_categorised_tests;
    } catch (e) {
      // fall back below
    }
  }
  const companyInfo = await client(`api/companies/current/`);
  return companyInfo?.enabled_categorised_tests;
};
